import { Pipe, PipeTransform } from '@angular/core';
import { getSubscriptionName } from '@app/utilities/_index';

@Pipe({
  name: 'subscription',
  standalone: false,
})
export class SubscriptionPipe implements PipeTransform {
  /**
   * Transform and return subscription slug string to subscription name
   * @param subscription - subscription slug params to be transformed
   * @returns - transformed subscription name string, else default to empty for unknown subscription
   */
  public transform(subscription: string): string {
    return getSubscriptionName(subscription);
  }
}
